import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalqueryvoice-card',
  templateUrl: './helpbutton-reports-totalqueryvoice-card.component.html',
  styleUrls: ['./helpbutton-reports-totalqueryvoice-card.component.scss']
})
export class HelpbuttonReportsTotalqueryvoiceCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
